module.exports = __webpack_public_path__ + "static/img/speed-stop-s.bda4ceda.png";